// extracted by mini-css-extract-plugin
module.exports = {"responsavel":"Registro_responsavel__2m6-u","foto":"Registro_foto__34a3K","iconeUsuario":"Registro_iconeUsuario__2VQLw"};